module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-tabbed-client-invoices"
  }, [_c('ActionBar', [_c('h2', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Invoices")]), (_vm.expanded) ? _c('InvoiceListForm', {
    attrs: {
      "slot": "action",
      "type": "entity-filter"
    },
    on: {
      "filterInvoices": _vm.filterInvoices
    },
    slot: "action"
  }) : _vm._e(), (_vm.expanded) ? _c('InvoiceListForm', {
    attrs: {
      "slot": "action",
      "type": "type-filter"
    },
    on: {
      "filterInvoices": _vm.filterInvoices
    },
    slot: "action"
  }) : _vm._e(), _c('i', {
    staticClass: "fa fa-2x",
    class: {
      'fa-eye-slash': _vm.expanded, 'fa-eye': !_vm.expanded
    },
    attrs: {
      "slot": "action"
    },
    on: {
      "click": function($event) {
        _vm.expanded = !_vm.expanded
      }
    },
    slot: "action"
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expanded),
      expression: "expanded"
    }],
    staticClass: "tabs-inner-content"
  }, [_c('div', {
    staticClass: "text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'credit-note',
        params: {
          client_id: _vm.$route.params.id,
          wallet_id: _vm.wallet.id
        }
      }
    }
  }, [_c('span', {
    staticClass: "button"
  }, [_vm._v("Emit manual credit note")])])], 1)]), _c('base-list', {
    attrs: {
      "component": _vm.component,
      "search": _vm.search,
      "dataLoader": _vm.dataLoader,
      "resultsPerPage": 5,
      "componentType": "client-invoices"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0bd5eb4d!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/ClientInvoices.vue
// module id = 2255
// module chunks = 1